module.exports = __webpack_public_path__ + "img/kankou_16.1f2e6e13.jpg";